import React from 'react';
import { StyledFooter as PantheonFooter } from '@minerva-analytics/pantheon';
import { WHITE, CHARCOAL } from '../../theme';

const Footer = () => {

  const SocialButtons = {
    medium: 'https://medium.com/@thequickscope',
    twitter: 'https://twitter.com/TheQSNews',
    facebook: 'https://www.facebook.com/QuickScopeNews',
    instagram: 'https://www.instagram.com/quickscopenews',
  };

  const links = [
    {
      to:`/terms`, 
      title: `TERMS OF USE`
    },
    {
      to:`/privacy`, 
      title: `PRIVACY POLICY`
    },
    {
      to:`/cookie`, 
      title: `COOKIE POLICY`
    },
    {
      to:`/ccpa`, 
      title: `CA PRIVACY POLICY`
    },
    {
      to:`https://quickscope.minervaarticles.com/articles/eaef89216245e3044d269799580a31/rss/`, 
      title:`RSS FEED`, 
      external: true
    }
  ];

  return (
    <PantheonFooter
      productName="QUICKSCOPE"
      productLogo="https://storage.googleapis.com/quickscope/assets/quickscope_favicon.png"
      textColor={WHITE}
      font='Roboto'
      backgroundColor={CHARCOAL}
      socialButtons={SocialButtons}
      links={links}
    />
  );
}

export default Footer;